
import React, { useState } from 'react';
import axios from 'axios';
import {
    TextField,
    Button,
    Grid,
    Paper,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; // For date handling
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';
import { setSnackbar } from '../../../../../components/hooks/snackBar/reducers';
import { Helmet } from 'react-helmet-async';

const BarcodeForm = () => {
    const dispatch = useDispatch()

    const [barcode, setBarcode] = useState('');
    const [data, setData] = useState({
        docno: '',
        docdate: null,
        sup_name: '',
        sup_code: '',
        osd_billno: '',
        osd_docdate: null,
        transfer_docdate: null,
        mobile: '',
        party_name: '',
        pur_rate: '',
        units_short_name: '',
        head_name: '',
        type_name: '',
        category_name: '',
        subcategory_name: '',
        outlet_full_name: '',
        status_name: '',
        aging: ''
    });

    // Fetch Data Function (POST request with payload)
    const fetchBarcodeDetails = async (barcodeValue) => {
        if (!barcodeValue) return; // Prevent API call if the input is empty

        try {
            const response = await axios.post('/v1/barcode/complete/history', {
                barcode: barcodeValue, // Send barcode in the payload
            });
            setData(response.data);
        } catch (error) {
            dispatch(setSnackbar(true, 'error', error.response.data.errors[0].message))

            console.error('Error fetching barcode details:', error);
        }
    };

    // Clear Function
    const clearData = () => {
        setData({
            docno: '',
            docdate: null,
            sup_name: '',
            sup_code: '',
            osd_billno: '',
            osd_docdate: null,
            transfer_docdate: null,
            mobile: '',
            party_name: '',
            pur_rate: '',
            units_short_name: '',
            head_name: '',
            type_name: '',
            category_name: '',
            subcategory_name: '',
            status_name: '',
            outlet_full_name: '',
            transfer_docno: '',
            aging: ''
        });
        setBarcode('');
    };

    // Handle Barcode Change and Enter Key
    const handleBarcodeChange = (e) => {
        setBarcode(e.target.value);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            fetchBarcodeDetails(barcode); // Call API only on Enter key press
        }
    };

    // Handle Date Change
    const handleDateChange = (field, value) => {
        setData((prevState) => ({
            ...prevState,
            [field]: value ? dayjs(value).format('YYYY-MM-DD') : '',
        }));
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Helmet><title>Barcode History</title></Helmet>
            <Paper style={{ padding: '20px', margin: '20px', backgroundColor: '#f9f9f9' }}>
            <Typography variant="h5" gutterBottom>
                    Barcode History
                </Typography>
                <Grid container spacing={2} style={{ marginTop: '20px' }}>
                <Grid item xs={12} md={4} lg={3}>
          
          <Typography variant="subtitle1">Barcode</Typography>
          <TextField
          size="small"
              // label="Barcode"
              variant="outlined"
              fullWidth
              value={barcode}
              onChange={handleBarcodeChange}
              onKeyPress={handleKeyPress} // Call API only on Enter key press
          />
          
              </Grid>
              </Grid>
                <Grid container spacing={2} style={{ marginTop: '20px' }}>
              
                <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Supplier Name</Typography>
                        <TextField
                        size="small"
                            // label="Supplier Name"
                            variant="outlined"
                            fullWidth
                            value={data.sup_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Supplier Code</Typography>
                        <TextField
                        size="small"
                            // label="Supplier Code"
                            variant="outlined"
                            fullWidth
                            value={data.sup_code}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Subcategory Name</Typography>
                        <TextField
                        size="small"
                            // label="Subcategory Name"
                            variant="outlined"
                            fullWidth
                            value={data.subcategory_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Main Category</Typography>
                        <TextField
                        size="small"
                            // label="Category Name"
                            variant="outlined"
                            fullWidth
                            value={data.category_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                   
                <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Purchase No</Typography>
                        <TextField
                        size="small"
                            // label="Bill No"
                            variant="outlined"
                            fullWidth
                            value={data.docno}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Purchase Date</Typography>
                        <DatePicker
                
                            // label="Document Date"
                            slotProps={{
                                textField: {
                                    size: "small",
                                  // label:'Expiry Date',
                                  style:{width : '100%',marginBlock:2}
                                },
                              }}
                            value={data.docdate ? dayjs(data.docdate) : null}
                            onChange={(newValue) => handleDateChange('docdate', newValue)}
                            renderInput={(params) => <TextField {...params} fullWidth />}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Purchase Price</Typography>
                        <TextField
                        size="small"
                            // label="Purchase Rate"
                            variant="outlined"
                            fullWidth
                            value={data.pur_rate}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Bill No</Typography>
                        <TextField
                        size="small"
                            // label="OSD Bill Number"
                            variant="outlined"
                            fullWidth
                            value={data.osd_billno}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    {/* <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Bill Date</Typography>
                        <DatePicker
        
                            // label="OSD Document Date"
                            slotProps={{
                                textField: {
                                    size: "small",
                                  // label:'Expiry Date',
                                  style:{width : '100%',marginBlock:2}
                                  
                                },
                              }}
                            value={data.osd_docdate ? dayjs(data.osd_docdate) : null}
                            onChange={(newValue) => handleDateChange('osd_docdate', newValue)}
                            renderInput={(params) => <TextField  {...params} fullWidth />}
                        />
                    </Grid> */}
                     {/* changed bill date not for unsold */}
                     <Grid item xs={12} md={4} lg={3}>
                                  <Typography variant="subtitle1">Bill Date</Typography>
                                 <DatePicker
                                   slotProps={{
                                   textField: {
                                   size: "small",
                                   style: { width: '100%', marginBlock: 2 }
                                 },
                               }}
                                 value={
                                 data.status_name && data.status_name.toLowerCase() === 'sold'
                                 ? (data.osd_docdate ? dayjs(data.osd_docdate) : null)
                                 : null
                                }
                              onChange={
                              data.status_name && data.status_name.toLowerCase() === 'sold'
                             ? (newValue) => handleDateChange('osd_docdate', newValue)
                             : undefined
                             }
                             disabled={!(data.status_name && data.status_name.toLowerCase() === 'sold')}
                             />
                        </Grid>
                        
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Cust Mobile</Typography>
                        <TextField
                        size="small"
                            // label="Mobile"
                            variant="outlined"
                            fullWidth
                            value={data.mobile}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Cust Name</Typography>
                        <TextField
                        size="small"
                            // label="Party Name"
                            variant="outlined"
                            fullWidth
                            value={data.party_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                

                    {/* <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Unit Short Name</Typography>
                        <TextField
                            // label="Unit Short Name"
                            variant="outlined"
                            fullWidth
                            value={data.units_short_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Head</Typography>
                        <TextField
                            // label="Head Name"
                            variant="outlined"
                            fullWidth
                            value={data.head_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid> */}
                    {/* <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Type Name</Typography>
                        <TextField
                            // label="Type Name"
                            variant="outlined"
                            fullWidth
                            value={data.type_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid> */}
                  
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Aging</Typography>
                        <TextField
                        size="small"
                            // label="Aging"
                            variant="outlined"
                            fullWidth
                            value={data.aging}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Status</Typography>
                        <TextField
                        size="small"
                            // label="Aging"
                            variant="outlined"
                            fullWidth
                            value={data.status_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Location</Typography>
                        <TextField
                        size="small"
                            // label="Aging"
                            variant="outlined"
                            fullWidth
                            value={data.outlet_full_name}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Transfer D.No</Typography>
                        <TextField
                        size="small"
                            // label="Aging"
                            variant="outlined"
                            fullWidth
                            value={data.transfer_docno}
                            InputProps={{
                                readOnly: true,
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={4} lg={3}>
                        <Typography variant="subtitle1">Transfer Date</Typography>
                        <DatePicker
        
                            // label="OSD Document Date"
                            slotProps={{
                                textField: {
                                    size: "small",
                                  // label:'Expiry Date',
                                  style:{width : '100%',marginBlock:2}
                                  
                                },
                              }}
                            value={data.transfer_docdate ? dayjs(data.transfer_docdate) : null}
                            onChange={(newValue) => handleDateChange('transfer_docdate', newValue)}
                            renderInput={(params) => <TextField  {...params} fullWidth />}
                        />
                    </Grid>
                </Grid>
                <Button 
                    variant="contained" 
                    color="primary" 
                    style={{ marginTop: '20px' }} 
                    onClick={clearData}
                >
                    CLEAR
                </Button>
            </Paper>
        </LocalizationProvider>
    );
};

export default BarcodeForm;
